import mailboxAxios from "../utils/mailboxAxios";

export const accessApi = {
  getMyAccess: (token) =>
    mailboxAxios.get("/access/me-access", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  getAccessUsers: () => mailboxAxios.get("/admin/access/users"),
  getUserAccessDetail: (userId) => mailboxAxios.get(`/admin/access/users/${userId}/access`),

  getHrRoleMappings: () => mailboxAxios.get("/admin/access/hr-role-mappings"),

  getScopeRules: () => mailboxAxios.get("/admin/access/scope-rules"),
  createScopeRule: (payload) => mailboxAxios.post("/admin/access/scope-rules", payload),
  updateScopeRule: (id, payload) => mailboxAxios.put(`/admin/access/scope-rules/${id}`, payload),
  deleteScopeRule: (id) => mailboxAxios.delete(`/admin/access/scope-rules/${id}`),

  getPolicies: (params = {}) => mailboxAxios.get("/admin/access/policies", { params }),
  createPolicy: (payload) => mailboxAxios.post("/admin/access/policies", payload),
  updatePolicy: (id, payload) => mailboxAxios.put(`/admin/access/policies/${id}`, payload),
  updatePolicyStatus: (id, payload) =>  mailboxAxios.patch(`/admin/access/policies/${id}/status`, payload),
  getPolicyDetail: (id) =>  mailboxAxios.get(`/admin/access/policies/${id}`),
  getAvailablePermissionsForPolicy: (id, params) =>  mailboxAxios.get(`/admin/access/policies/${id}/available-permissions`, { params }),
  addPolicyPermission: (id, payload) =>  mailboxAxios.post(`/admin/access/policies/${id}/permissions`, payload),
  removePolicyPermission: (mappingId, payload = {}) =>  mailboxAxios.delete(`/admin/access/policy-permissions/${mappingId}`, { data: payload, }),

  getModules: () => mailboxAxios.get("/admin/access/modules"),
  createModule: (payload) => mailboxAxios.post("/admin/access/modules", payload),
  updateModule: (id, payload) => mailboxAxios.put(`/admin/access/modules/${id}`, payload),
  updateModuleStatus: (id, payload) => mailboxAxios.patch(`/admin/access/modules/${id}/status`, payload),

  getPermissions: (params) => mailboxAxios.get("/admin/access/permissions", { params }),
  createPermission: (payload) => mailboxAxios.post("/admin/access/permissions", payload),
  updatePermission: (id, payload) => mailboxAxios.put(`/admin/access/permissions/${id}`, payload),
  updatePermissionStatus: (id, payload) =>  mailboxAxios.patch(`/admin/access/permissions/${id}/status`, payload),

  createHrRolePolicyMapping: (payload) =>  mailboxAxios.post("/admin/access/hr-role-mappings", payload),
  deleteHrRolePolicyMapping: (id, payload = {}) =>  mailboxAxios.delete(`/admin/access/hr-role-mappings/${id}`, { data: payload, }),

  getItAuditLogs: (params = {}) => mailboxAxios.get("/it/audit", { params }),

  getMailAccounts: () => mailboxAxios.get("/admin/mail/accounts"),
  getMailAccountAccess: (accountId) => mailboxAxios.get(`/admin/mail/accounts/${accountId}/access`),
  createMailAccountAccess: (accountId, payload) =>   mailboxAxios.post(`/admin/mail/accounts/${accountId}/access`, payload),
  updateMailAccountAccess: (id, payload) =>   mailboxAxios.put(`/admin/mail/account-users/${id}`, payload),
  deleteMailAccountAccess: (id) =>   mailboxAxios.delete(`/admin/mail/account-users/${id}`),
  searchMailboxUsers: (q) =>   mailboxAxios.get("/admin/mail/users/search", { params: { q } }),

  getMailSignatureTemplates: () => mailboxAxios.get("/admin/mail/signature-templates"),
  createMailSignatureTemplate: (payload) => mailboxAxios.post("/admin/mail/signature-templates", payload),
  updateMailSignatureTemplate: (id, payload) => mailboxAxios.put(`/admin/mail/signature-templates/${id}`, payload),
  setDefaultMailSignatureTemplate: (id) => mailboxAxios.post(`/admin/mail/signature-templates/${id}/default`),
  generateAllMailSignaturesFromTemplate: (id) => mailboxAxios.post(`/admin/mail/signature-templates/${id}/generate-all`),

  getMailSignatureProfiles: (params) => mailboxAxios.get("/admin/mail/signature-profiles", { params }),
  getMailSignatureProfile: (userId) => mailboxAxios.get(`/admin/mail/signature-profiles/${userId}`),
  updateMailSignatureProfile: (userId, payload) => mailboxAxios.put(`/admin/mail/signature-profiles/${userId}`, payload),
  syncMailSignatureProfilesFromUsers: () => mailboxAxios.post("/admin/mail/signature-profiles/sync-from-users"),
  syncMailSignatureProfilesFromHr: () => mailboxAxios.post("/admin/mail/signature-profiles/sync-from-hr"),
  generateMailSignatureForUser: (userId, payload) => mailboxAxios.post(`/admin/mail/signature-profiles/${userId}/generate`, payload),
  deleteMailSignatureTemplate: (id) => mailboxAxios.delete(`/admin/mail/signature-templates/${id}`),

  getMailSignatureBrandingDefaults: () => mailboxAxios.get("/admin/mail/signature-branding-defaults"),
  updateMailSignatureBrandingDefaults: (payload) => mailboxAxios.put("/admin/mail/signature-branding-defaults", payload),
};